import {Component, OnDestroy, OnInit} from '@angular/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {MatDialog, MatSnackBar} from '@angular/material';
import {DialogSharedComponent} from '@components/dialog-shared/dialog-shared.component';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState} from '@store/reducers/index';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';
import {RemoveAddresses, SetActiveAddressesSearch} from "@store/actions/addresses.action";
import {LoadAddresses} from "@store/actions";
import {selectAddresses, selectFooterAction} from "@store/reducers";
import {FooterActionEnum} from "@models/footer-action.enum";
import { AccountService } from '@services/account.service';


@Component({
  selector: 'app-address-book',
  templateUrl: './address-book.component.html',
  styleUrls: ['./address-book.component.scss']
})
export class AddressBookComponent implements OnInit, OnDestroy {
  addressBooks;
  currentPageSize = 25;
  currentPage = 1;
  selectedAddresses = [];
  total: number;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    public faService: FontAwesomeService,
    public router: Router,
    public dialog: MatDialog,
    public store: Store<AppState>,
    public accountService: AccountService,
    public matSnackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    this.store.dispatch(new LoadAddresses({
      current_page_size: this.currentPageSize,
      current_page: this.currentPage,
    }));
    this.store.select(selectAddresses)
      .subscribe(data => {
        if (!data.data) {
          return;
        }
        if (data.activeSearch) {
          this.addressBooks = data &&
            data.filteredData &&
            data.filteredData[data.activeSearch] &&
            data.filteredData[data.activeSearch].data &&
            data.filteredData[data.activeSearch].data[this.currentPageSize] &&
            data.filteredData[data.activeSearch].data[this.currentPageSize][this.currentPage];
          this.total = data &&
            data.filteredData &&
            data.filteredData[data.activeSearch] &&
            data.filteredData[data.activeSearch][this.currentPageSize] &&
            data.filteredData[data.activeSearch][this.currentPageSize].total;
        } else {
          this.addressBooks = data.data &&
            data.data[this.currentPageSize] &&
            data.data[this.currentPageSize][this.currentPage];
          this.total = data.total;
        }
      });

    this.store.select(selectFooterAction)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(action => {
        if (action === FooterActionEnum.DELETE_SELECTED_ADDRESSES) {
          this.store.dispatch(new RemoveAddresses({
            ids: this.selectedAddresses,
            current_page: this.currentPage,
            current_page_size: this.currentPageSize
          }));
          this.selectedAddresses = [];
        }
      });
  }

  goToAddressBook(id) {
    this.router.navigate(
      ['/address-book/edit', id]
    );
  }

  removeAddress(addressBook) {
    const dialogRef = this.dialog.open(DialogSharedComponent,
      {width: '450px', data: {id: addressBook.name, bodyModalText: 'addressBook.remove'}});
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'true') {
        this.store.dispatch(
          new RemoveAddresses({
            ids: [addressBook.id],
            current_page: this.currentPage,
            current_page_size: this.currentPageSize
          })
        );
      }
    });
  }

  applyFilter(activeSearch: string) {
    this.currentPage = 1;
    this.store.dispatch(new SetActiveAddressesSearch({
      current_page_size: this.currentPageSize,
      current_page: this.currentPage,
      activeSearch
    }));
  }

  handleSelectCheckbox(id) {
    if (this.selectedAddresses.includes(id)) {
      this.selectedAddresses = this.selectedAddresses.filter(shipmentId => shipmentId !== id);
    } else {
      this.selectedAddresses.push(id);
    }
  }

  handleSelectAll(selected) {
    if (selected) {
      this.selectedAddresses = [];
      this.addressBooks.forEach(({id}) => this.selectedAddresses.push(id));
    } else {
      this.selectedAddresses = [];
    }
  }

  handleChangeDisplayedAddresses(page) {
    this.currentPage = page;
    this.store.dispatch(new LoadAddresses({
      current_page_size: this.currentPageSize,
      current_page: this.currentPage,
    }));
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/address-book/address-book.component.ts